import type { GetServerSideProps, NextPage } from 'next';
import dynamic from 'next/dynamic';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import type { Contact } from '@mwl/core-lib';
import { checkUserAuthOnServer, getContacts } from '@mwl/core-lib';
import { defaultLocale } from '@/constants';
import { wrapperStore } from '@/store/store';
import { getNamespaces } from '@/utils';
const Layout = dynamic(() => import('@/Layouts/Layout/Layout').then(mod => mod.Layout));
const ContactsPage = dynamic(() => import('@/modules/contacts/ContactsPage').then(mod => mod.ContactsPage));
interface ContactsProps {
  contacts: Array<Contact>;
}
const findTypes = ['email', 'link', 'phone'];
const Contacts: NextPage<ContactsProps> = ({
  contacts
}) => {
  return <Layout data-sentry-element="Layout" data-sentry-component="Contacts" data-sentry-source-file="contacts.tsx">
      <ContactsPage contacts={contacts} data-sentry-element="ContactsPage" data-sentry-source-file="contacts.tsx" />
    </Layout>;
};
export const getServerSideProps: GetServerSideProps<ContactsProps> = wrapperStore.getServerSideProps(({
  dispatch
}) => async ({
  locale = defaultLocale,
  req,
  res
}) => {
  const {
    localServerAxiosInstance
  } = await checkUserAuthOnServer({
    dispatch,
    locale,
    res,
    req
  });
  const {
    data,
    status
  } = await getContacts({
    group: 'COMMON'
  }, undefined, localServerAxiosInstance);
  const contacts: Array<Contact> = [];
  if (status === 200 && data && data.length > 0) {
    data.forEach(contactItem => {
      if (findTypes.includes(contactItem.type.toLowerCase())) {
        contacts.push(contactItem);
      }
    });
  }
  return {
    props: {
      ...(await serverSideTranslations(locale, getNamespaces('contacts'))),
      contacts
    }
  };
});
export default Contacts;